import { render } from "./SettingsView.vue?vue&type=template&id=05f6be51&ts=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__